// extracted by mini-css-extract-plugin
export default {"imageBox":"CategoryCompare_imageBox__MLiK5"};